// 获取URL查询参数
export const getQuery = (key) => {
    let value = '';

    try {
        const urlObj = new URL(location.href);
        const { searchParams } = urlObj;

        if (searchParams.has(key)) {
            value = searchParams.get(key);
        }
    } catch (e) {
        console.error(e);
    }

    return value;
};
